export class Filter {
  q?: object
  page?: number
  perPage?: number
}